<template>
    <div class="d-flex align-center">
        <div class="d-flex flex-column flex-1-0">
            <v-select
                v-model="newClient.prefix"
                variant="outlined"
                density="compact"
                :items="['Mr', 'Ms', 'Mrs']"
                :label="`${$t('title')}`"
                class="pb-3"
                hide-details
                data-cy="prefix"
            />
            <v-text-field
                v-model="newClient.firstName"
                variant="outlined"
                density="compact"
                :label="`${$t('first_name')}`"
                class="pb-3"
                hide-details
                data-cy="first-name"
            />
            <v-text-field
                v-model="newClient.lastName"
                variant="outlined"
                density="compact"
                :label="`${$t('last_name')}`"
                hide-details
                data-cy="last-name"
            />
        </div>
        <v-btn
            class="ms-2"
            icon="mdi-check-circle-outline"
            variant="text"
            color="success"
            density="compact"
            data-cy="save"
            @click="save"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OrderDetailsEditClient extends Vue {
        @Prop({required: true}) saveLoading
        @Prop({required: true}) clientPerson

        newClient = {}

        async mounted() {
            await this.load()
        }

        async load() {
            this.newClient = {...this.clientPerson}
        }

        @Emit()
        save() {
            return {
                firstName: this.newClient.firstName,
                lastName: this.newClient.lastName,
                prefix: this.newClient.prefix,
            }
        }
    }

    export default OrderDetailsEditClient
</script>
